import ApartmentIcon from '@mui/icons-material/Apartment';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import ScienceIcon from '@mui/icons-material/Science';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Avatar, Box, Button, IconButton, Typography } from "@mui/material";
import "../CSS/DrXu.css";
import "../CSS/Layout.css";
import { academicPositionList, awardList, courseList, educationList, xfNewsList } from "../Configurations/DrXuList";
import { redirect } from "../utils/tools";

export default function DrXuPage() {
  const AcademicPositions = () => {
    let positions = [];
    for (var i = 0; i < academicPositionList.length; i++) {
      let detail = academicPositionList[i];
      positions.push(
        <Box key={i} className="position-list">
          <Typography
            fontSize="20px"
            color="primary"
            textAlign="left"
            fontWeight="bold"
          >
            {detail.time}
          </Typography>
          <Box className="flex-column-left" gap="5px">
            <Typography fontSize="20px" fontWeight="bold" color="secondary">{detail.title}</Typography>
            <Typography>{detail.company}</Typography>
            <Typography>{detail.location}</Typography>
          </Box>
        </Box>
      );
    }
    return positions;
  };

  const Educations = () => {
    let stepBlock = [];
    for (var i = 0; i < educationList.length; i++) {
      let detail = educationList[i];
      stepBlock.push(
        <Box className="xf-step-grid" key={i}>
          <Box component="img"
            className='xf-step-img'
            alt={detail.location}
            src={detail.logo}
          />
          <Box pt={"0.5rem"} ml="0.8rem">
            <Typography fontWeight={"bold"} color="primary" fontSize={"1.2rem"}>{detail.time}</Typography>
            <Typography mb="0.5rem" fontWeight={200}>{detail.location}</Typography>
            <Typography>{detail.description}</Typography>
          </Box>
          <Box className="xf-step-connector" />
          <Box />
        </Box>
      );
    }
    return stepBlock;
  }

  const awardSection = () => {
    let awards = [];
    for (var i = 0; i < awardList.length; i++) {
      awards.push(<Box key={i} display="grid" gridTemplateColumns="4rem 1fr" className="grid-center">
        <Typography fontWeight={"bold"} fontSize="1.2rem" color="primary">{awardList[i].time}</Typography>
        <Typography>{awardList[i].description}</Typography>
      </Box>);
    }
    return <Box display="flex" flexDirection="column" gap="0.5rem">
      {awards}
    </Box>;
  }

  const newsSection = () => {
    const news = [];
    for (var i = 0; i < xfNewsList.length; i++) {
      let detail = xfNewsList[i];
      news.push(<Button key={i} sx={{ justifyContent: "flex-start" }}
        onClick={() => { redirect(detail.link) }}>
        <Box className="media-list">
          <Typography color="primary">{detail.time}</Typography>
          <Typography color="secondary">{detail.title}</Typography>
        </Box>
      </Button >);
    }
    return news;
  };

  const courseSection = () => {
    let courses = [];
    for (var i = 0; i < courseList.length; i++) {
      courses.push(<Box key={i} display="grid" gridTemplateColumns="10rem 1fr">
        <Typography color="primary">{courseList[i].id}</Typography>
        <Typography>{courseList[i].description}</Typography>
      </Box>);
    }
    return courses;
  }

  return (<Box className="profile-sections">
    <Box className="with-color">
      <Box className="upper-section">
        <Avatar className="xf-avatar" alt="Dr. Xu" src="/people/xu-fang.jpg" />
      </Box>

      <Typography variant='h1'>Contact</Typography>
      <Box className="xf-contact">
        <Box display="flex">
          <ApartmentIcon />
          <Typography fontWeight={"bold"}>Office</Typography>
        </Box>
        <Typography>BSE 0.104L </Typography>
        <Box display="flex">
          <PhoneIcon />
          <Typography fontWeight={"bold"}>Phone</Typography>
        </Box>
        <Typography>(210) 458-5774 </Typography>
        <Box display="flex">
          <EmailIcon />
          <Typography fontWeight={"bold"}>Email</Typography>
        </Box>
        <Typography >fang.xu@utsa.edu </Typography>
        <Box display="flex">
          <ScienceIcon />
          <Typography fontWeight={"bold"}>Lab</Typography>
        </Box>
        <Typography>BSE 0.224, BSE 0.304D</Typography>
      </Box>
      <Typography variant='h1'>Social Media</Typography>
      <Box display={"flex"}>
        <IconButton color="secondary" onClick={() => redirect("https://www.linkedin.com/in/fang-xu-725b6831")}>
          <LinkedInIcon sx={{ fontSize: "3rem" }} />
        </IconButton>
        <IconButton color="secondary" onClick={() => redirect("https://www.youtube.com/@xustm6405")}>
          <YouTubeIcon sx={{ fontSize: "3rem" }} />
        </IconButton>
        <IconButton color="secondary" onClick={() => redirect("https://scholar.google.com/citations?hl=en&user=lfGba84AAAAJ&hl=en")}>
          <Box component="img"
            src="/logos/googleScholar.png"
            height="2.7rem"
          />
        </IconButton>
      </Box>
    </Box>

    <Box className="without-color">
      <Box className="flex-row-left" gap="1rem" mt="2rem">
        <Typography fontWeight={70} fontSize="4.5rem">
          Fang
        </Typography>
        <Typography fontWeight={800} fontSize="4.5rem">{"Xu"}</Typography>
      </Box>
      <Typography mt="0.5rem" fontSize="1.8rem">Assistant Professor</Typography>
      <Typography fontSize="1.8rem">Department of Chemistry, University of Texas at San Antonio</Typography>
      <Typography mt={"1.5rem"} fontWeight={300} textAlign="justify">
        <p>
          Greetings! I am a chemist by training and focused on surface science in the realm of heterogeneous catalysis during both my Ph.D. and postdoctoral training. My overarching goal is to contribute fundamental insights to materials, energy, and environmental sciences by examining atomic and molecular-level phenomena, extending beyond the confines of heterogeneous catalysis. I am deeply grateful for the support provided by my mentors and am committed to investing all my efforts into fostering the individual success of the students. In addition to my academic pursuits, I am an advocate for science outreach to the public. My lab and I have actively participated in multiple outreach activities, including events like the lab open house at UTSA Day and KLRN's S.E.E Your Future Career Day.
        </p>
      </Typography>
      <Typography variant='h1'>Academic Positions</Typography>
      <Box className="flex-column-left" gap="1rem">
        {AcademicPositions()}
      </Box>
      <Typography variant='h1'>Education and Professional Training</Typography>
      {Educations()}
      <Typography variant='h1'>Awards</Typography>
      {awardSection()}
      <Typography variant='h1'>News On Media</Typography>
      {newsSection()}
      <Typography variant='h1'>Courses at UTSA</Typography>
      {courseSection()}
      <Box mb="2rem" />
    </Box>
  </Box>);
}